import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import { Pagination } from 'antd';
import React from 'react';
import './index.scss';

function AppPagination({
  totalItems,
  pageSize,
  pageIndex,
  onPageChange = () => {},
  onPageSizeChange = () => {},
  showSizeChanger = true,
}) {
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);
  return (
    <Pagination
      total={totalItems}
      pageSize={pageSize}
      current={pageIndex}
      onChange={(page, size) => {
        onPageChange(page);
        onPageSizeChange?.(size);
      }}
      showSizeChanger={showSizeChanger && totalItems > 10}
      showTotal={(total, range) =>
        total > 1 ? `${range[0]}-${range[1]} of ${total} items` : `${total} item`
      }
      size={isMobile ? 'small' : 'default'}
      showLessItems={isMobile}
      showQuickJumper
      align={isMobile ? 'center' : 'end'}
      className="flex-wrap gap-1"
    />
  );
}

export default AppPagination;
